import {FunctionComponent} from 'react';

import styles from './loading-spinner.module.css';

const LoadingSpinner: FunctionComponent = () => (
  <span className={styles.loader}></span>
);
export default LoadingSpinner;
